import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full h-full justify-start items-start bg-white overflow-y-auto" }
const _hoisted_2 = { class: "flex flex-col px-4 gap-4 mt-4 w-full items-center" }
const _hoisted_3 = { class: "flex flex-col gap-4 mt-4 w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_alert = _resolveComponent("el-alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "w-full h-12 p-4 shadow-md" }, [
      _createElementVNode("span", { class: "text-large text-black text-bold font-600 mr-3" }, "Layout3")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        class: "w-24",
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.drawer = true))
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode(" open ")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        plain: "",
        onClick: _ctx.open2
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode(" Won't close automatically ")
        ])),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _ctx.openFullScreen2
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createTextVNode(" As a service ")
        ])),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_drawer, {
        modelValue: _ctx.drawer,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.drawer) = $event)),
        size: 300,
        title: "I am the title",
        "with-header": false
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createElementVNode("span", null, "Hi there!", -1)
        ])),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_alert, {
          title: "Success alert",
          type: "success"
        }),
        _createVNode(_component_el_alert, {
          title: "Info alert",
          type: "info"
        }),
        _createVNode(_component_el_alert, {
          title: "Warning alert",
          type: "warning"
        }),
        _createVNode(_component_el_alert, {
          title: "Error alert",
          type: "error"
        })
      ])
    ])
  ]))
}